<app-summary-field [label]="label">
  <app-bmi-label [height]="height" [weight]="weight"></app-bmi-label>
</app-summary-field>
